import type { FoodTypeId } from "../domain/types";
import { TablerIcon } from "./TablerIcon";

/**
 * Only food types with a literal, unambiguous Tabler icon are listed here.
 * Tabler has no icon for curry, stir-fry, tray-bake/casserole, or
 * pasta/noodles that isn't a misleading stand-in, so those food types render
 * with no icon rather than an approximate one. See TablerIcon for sourcing.
 */
const ICON_PATHS: Partial<Record<FoodTypeId, string[]>> = {
  "soup-stew": [
    "M4 11h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1",
    "M12 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2",
    "M16 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2",
    "M8 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2",
  ],
  "grain-bowl": [
    "M4 8h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1",
  ],
  salad: [
    "M4 11h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1",
    "M18.5 11c.351 -1.017 .426 -2.236 .5 -3.714v-1.286h-2.256c-2.83 0 -4.616 .804 -5.64 2.076",
    "M5.255 11.008a12.204 12.204 0 0 1 -.255 -2.008v-1h1.755c.98 0 1.801 .124 2.479 .35",
    "M8 8l1 -4l4 2.5",
    "M13 11v-.5a2.5 2.5 0 1 0 -5 0v.5",
  ],
};

interface Props {
  foodTypeId: FoodTypeId;
}

export function FoodTypeGlyph({ foodTypeId }: Props) {
  const paths = ICON_PATHS[foodTypeId];
  if (!paths) return null;
  return <TablerIcon paths={paths} className="food-type-icon" />;
}
